import { faLocationDot } from '@fortawesome/pro-regular-svg-icons';
import { faBicycle, faCar, faPerson, faTrainSubway } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ScheduleData } from '@/modules/league/new-components/types';

export default function DetailsFooter({ session, location }: ScheduleData) {
  const iconData = [
    { icon: faCar, label: 'Car' },
    { icon: faPerson, label: 'Person' },
    { icon: faTrainSubway, label: 'Train/Subway' },
    { icon: faBicycle, label: 'Bicycle' },
  ];

  const iconStyle = {
    base: 'ml-2 inline-flex h-6 w-6 items-center justify-center rounded-full border-2 border-gray-900 bg-white p-2 text-xl font-bold text-gray-900 hover:border-gray-900 hover:bg-gray-900 hover:text-white md:w-7 md:h-7',
  };

  return (
    <div className='mb-4 w-full rounded-lg bg-gray-100 p-4 text-center text-sm text-gray-700 md:text-lg'>
      <div className='flex justify-center p-4'>
        {iconData.map(({ icon, label }) => (
          <FontAwesomeIcon key={label} className={iconStyle.base} icon={icon} size='xl' />
        ))}
      </div>
      <FontAwesomeIcon className='mr-2 text-2xl' icon={faLocationDot} />
      <div>
        <span className='font-semibold'>{session?.LeagueTitle}</span>
        <br />
        at
        <br />
        <span className='font-semibold'>{session?.Location_Title}</span>
        <br />
        {location?.Location_StreetAddress}
        <br />
        {location?.Location_City}, {location?.StateTitle} {location?.Zip}
        <br />
        {location?.CountryTitle}
      </div>
    </div>
  );
}
